import { defaultMaskPropsGenerator } from '../../components/modal';
import { defaultContainerPropsGenerator } from '../../components/closeableModal';

export default {
	maskProps: defaultMaskPropsGenerator,
	containerProps: defaultContainerPropsGenerator,
};